import { z } from 'zod'
import { sensitiveDataCategoryOf, type SensitiveKeys } from './sensitive'
import { SensitiveDataCategorySchema } from './sensitiveDataCategorySchema'
import type { SensitiveDataCategory } from '@omnea-digital/authz-model'

/** Adds `redacted` to an object shape: it names each property of the shape that a response nulled because the caller cannot see its category. */
export function withRedacted<Shape extends z.ZodRawShape>(
  shape: Shape
): Shape & { redacted: z.ZodOptional<z.ZodType<Partial<Record<SensitiveKeys<Shape>, SensitiveDataCategory>>>> }
export function withRedacted(shape: z.ZodRawShape): z.ZodRawShape {
  const [first, ...rest] = Object.entries(shape).flatMap(([key, property]) =>
    sensitiveDataCategoryOf(property) === undefined ? [] : [key]
  )
  if (first === undefined) throw new Error('withRedacted: the shape declares no sensitive() property')
  return { ...shape, redacted: z.partialRecord(z.enum([first, ...rest]), SensitiveDataCategorySchema).optional() }
}

// A composite row the server did not hide: a masked row's `response` is null.
export const isShownRow = <Row extends { response: unknown }>(
  row: Row
): row is Row & { response: NonNullable<Row['response']> } => row.response != null
